import { dateFormat } from '@/Utils/publicUtils.js'

var OSS = require("ali-oss");
let url = '';

export default {
  /**
   * 创建随机字符串
   * @param num
   * @returns {string}
   */
  randomString(num) {
    const chars = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z"
    ];
    let res = "";
    for (let i = 0; i < num; i++) {
      var id = Math.ceil(Math.random() * 35);
      res += chars[id];
    }
    return res;
  },

  /**
   * 创建oss客户端对象
   * @returns {*}
   */
  createOssClient(region, accessKeyId, accessKeySecret, bucket, stsToken) {
    return new Promise((resolve, reject) => {
      const client = new OSS({
        region: region, //区域
        accessKeyId: accessKeyId, // KeyID
        accessKeySecret: accessKeySecret, // Key秘钥
        bucket: bucket, // 文件夹
        stsToken: stsToken,//stsToken
        secure: true // 上传链接返回支持https
      });
      resolve(client);
    });
  },
  /**
   * 文件上传
   * @param option 传递参数
   */
  ossUploadFile(option, hide, showp) {
    const file = option.file;
    const self = this;
    // var url = '';
    return new Promise((resolve, reject) => {
      const date = dateFormat(new Date(), "yyyyMMdd"); // 当前时间
      const dateTime = dateFormat(new Date(), "yyyyMMddhhmmss"); // 当前时间
      const randomStr = self.randomString(4); //  4位随机字符串
      const extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
      const fileName =
        "video/" + date + "/" + dateTime + "_" + randomStr + extensionName; // 文件名字（相对于根目录的路径 + 文件名）
      // 执行上传
      self.createOssClient(option.region, option.accessKeyId, option.accessKeySecret, option.bucket, option.stsToken).then(client => {


        // 上传处理
        // 分片上传文件
        client
          .multipartUpload(fileName, file, {
            progress: function (p) {
              let percent = Math.floor(p * 100);
              console.log('Progress: ' + percent);
              showp(percent);
            }
          })
          .then(
            val => {
              hide(false);
              window.url = val
              console.info('woc', url);
              if (val.res.statusCode === 200) {
                console.log('上传成功： val: ' + val);
                // 异步上传,返回数据
                resolve({
                  fileName: file.name,
                  fileUrl: fileName,
                  OssVal: val
                });
              } else {
                console.log('上传失败');
              }
            },
            err => {
              hide(false);
              console.log('上传失败');
              console.log('err :>> ', err);
              reject(err);
            }
          );
      });
    });
  },

  /**
   * Blob上传
   * @param option 传递参数
   */
  ossUploadBlob(option) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(option.blob);
      const self = this;
      const fileName = option.fileName; // 文件名字
      reader.onload = function (event) {
        const buffer = new OSS.Buffer(event.target.result);
        // 执行上传
        self.createOssClient(option.region, option.accessKeyId, option.accessKeySecret, option.bucket, option.stsToken).then(client => {
          // 上传
          client.put(fileName, buffer).then(function (result) {
            resolve(result);
          }).catch(function (err) {
            reject(err);
          });
        });
      }
    });
  }
};